var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { marks, mediaQueries, strMark } from 'Theme';
import { store as mainStore } from '../App';
import History, { toParentPath } from 'helpers/History';
import { t, T } from 'helpers/i18n';
import { Validation } from 'helpers/Validation';
import { mapValues, objectValues } from 'helpers/Utils';
import { Button, Field, FieldType } from 'elements';
import Calculator from './Calculator';
import { ButtonsBar } from '../Styles';
import PropTypes from 'prop-types';
import QueryParams from './QueryParams';
import { Col, Container, Row } from 'reactstrap';
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            values: {}
        };
        _this.handleChange = function (name, value, column) {
            if (_this.props.handleChange) {
                _this.props.handleChange(name, value, column);
                return;
            }
            // console.log('handleChange: ', `name: ${name} value: ${value} column: ${column}`)
            /*this.setState({values: {...this.state.values, [column? column: name]: value}}, () => {
              // console.log('handleChange: state.value', this.state.values)
            })*/
            _this.setState(function (prevState) {
                var _a;
                return ({ values: __assign(__assign({}, prevState.values), (_a = {}, _a[column ? column : name] = value, _a)) });
            });
        };
        _this.handleCancel = function () {
            // console.log('handleCancel')
            var onCancel = _this.props.onCancel;
            if (onCancel)
                return onCancel();
            toParentPath();
        };
        _this.handleDisable = function (disable) { return function () {
            // console.log('handleDisable')
            var _a = _this.props, values = _a.values, store = _a.store, onDisable = _a.onDisable;
            var accept = confirm(t(disable ? 'confirmDisable' : 'confirmEnable'));
            if (accept) {
                if (onDisable)
                    return onDisable(disable);
                if (store && store.disable && values) {
                    store.disable(values.id, disable).then(toParentPath);
                }
            }
        }; };
        _this.handleDelete = function () {
            /*console.log('handleDelete')
            const {values, store, onDelete} = this.props
        
            const accept = confirm(t('confirmDelete'))
            if (accept) {
              if (onDelete) return onDelete()
              if (store && store.delete && values) {
                store.delete(values.id).then(toParentPath)
              }
            }*/
        };
        _this.handleReset = function () {
            // console.log('handleReset')
            _this.setState({ values: _this.parsedValues() });
        };
        _this.handleSubmit = function () {
            var _a;
            var _b = _this.props, fields = _b.fields, propsValues = _b.values, store = _b.store, onSubmit = _b.onSubmit, handleSubmit = _b.handleSubmit;
            if (handleSubmit) { // si hay handleSubmit en props es el que procesa
                return handleSubmit({
                    propValues: _this.props,
                    stateValues: __assign({}, _this.state.values),
                    schema: _this.schema
                });
            }
            var values = __assign({}, _this.state.values);
            // console.log('handleSubmit - fields', fields)
            // console.log('handleSubmit - values', values)
            // console.log('handleSubmit - schema', this.schema)
            // console.log('handleSubmit - propsValues', propsValues)
            var validation = new Validation(values, _this.schema);
            if (validation.valid) {
                // Remove unmodified value
                // console.log('antes de fields.map - values', values)
                _this.fields.map(function (field) {
                    if (propsValues && values[field.column ? field.column : field.name] === propsValues[field.column ? field.column : field.name]) {
                        delete values[field.column ? field.column : field.name];
                    }
                });
                if (Object.keys(values).length === 0)
                    return mainStore.UI.newWarning(T('nothingModified'));
                // Convert empty strings to null
                // console.log('antes de mapValues - values', values)
                values = mapValues(values, function (value) { return (value === '' ? null : value); });
                // console.log('mapValues - values', values)
                // Use FormData instead of JSON if there is a image in value
                var data_1;
                if (Object.keys(_this.schema).includes('image')) {
                    // console.log('handleSubmit - image')
                    data_1 = new FormData();
                    Object.keys(values).forEach(function (key) {
                        if (values[key]) {
                            if (values[key] instanceof FileList) {
                                for (var i = 0; i < values[key].length; i++) {
                                    data_1.append(key, values[key][i]);
                                }
                            }
                            else {
                                data_1.append(key, values[key]);
                            }
                        }
                        else if (values[key] === null) {
                            data_1.append(key, '');
                        }
                    });
                }
                else {
                    data_1 = values;
                }
                // console.log('handleSubmit - data', data)
                if (onSubmit)
                    return onSubmit(data_1);
                if (store && data_1) {
                    var request = void 0;
                    if (propsValues) {
                        request = store.update(propsValues.id, data_1);
                    }
                    else {
                        var _data = data_1;
                        if (_this.props.sendIfIsCivitrip === true) {
                            var isCivitrip = ((_a = _this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
                            if (isCivitrip) {
                                _data['isCivitrip'] = true;
                            }
                        }
                        request = store.create(_data);
                    }
                    request.then(toParentPath);
                }
                else {
                    mainStore.UI.newWarning('error indefinido');
                }
            }
            else {
                mainStore.UI.newWarning(objectValues(validation.errors).join('\n'));
                // console.log('handleSubmit - !validation.valid - validation.errors', validation.errors)
            }
        };
        _this.fields = props.fields.filter(function (field) { return field; });
        _this.schema = _this.fields.reduce(function (previous, _a) {
            var name = _a.name, rules = _a.rules, column = _a.column;
            previous[column ? column : name] = rules;
            return previous;
        }, {});
        return _this;
    }
    Form.prototype.componentWillMount = function () {
        if (!this.props.handleChange) {
            this.setState({ values: this.parsedValues() });
        }
    };
    Form.prototype.render = function () {
        var _this = this;
        var _a = this.props, fields = _a.fields, canBeDeleted = _a.delete, loading = _a.loading, reactstrap = _a.reactstrap;
        var values = this.state.values;
        var canBeDisabled = 'disabled' in (this.props.values || {}) || 'disabled_at' in (this.props.values || {});
        var disabled = canBeDisabled && (this.props.values.disabled_at != null || this.props.values.disabled);
        var hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        // console.log('values: ', values)
        var taxValue = values.tax_id ? this.props.stores.taxes.findById(values.tax_id) : null;
        if (reactstrap) {
            return (React.createElement(Container, null,
                this.fields.reduce(function (rows, field, index) {
                    var _a;
                    var key = (_a = field.column) !== null && _a !== void 0 ? _a : field.name;
                    // const value = this.values[field.column ?? field.name]
                    var fieldWithValue = __assign(__assign({}, field), { value: values[field.column ? field.column : field.name] === 0 ? '0' : values[field.column ? field.column : field.name] || '' });
                    if (index % 3 === 0) {
                        rows.push([]);
                    }
                    rows[rows.length - 1].push(React.createElement(Col, { key: key, xl: 4, md: 6, sm: 12 },
                        React.createElement(Field, { key: field.column ? field.column : field.name, reactstrap: true, field: fieldWithValue, onChange: _this.handleChange })));
                    return rows;
                }, []).map(function (cols, rowIndex) { return (React.createElement(Row, { key: rowIndex, className: "align-items-center mb-3" }, cols)); }),
                taxValue && this.props.calculator &&
                    React.createElement(Calculator, { taxValue: taxValue, styles: { width: '100%', } }),
                React.createElement(ButtonsBar, null,
                    hasParent && (React.createElement(StyledButton, { onClick: this.handleCancel }, T('cancel'))),
                    this.props.values && canBeDisabled ? (disabled ? (React.createElement(StyledButton, { isDisabled: true, onClick: this.handleDisable(false) }, T('enable'))) : (React.createElement(StyledButton, { onClick: this.handleDisable(true) }, T('disable')))) /*: canBeDeleted ? (
                    <StyledButton onClick={this.handleDelete}>
                      {t('delete')}
                    </StyledButton>
                  )*/
                        : null,
                    React.createElement(StyledButton, { onClick: this.handleReset }, T('reset')),
                    React.createElement(StyledButton, { loading: loading, onClick: this.handleSubmit }, T('save')))));
        }
        return (React.createElement(Wrapper, null,
            this.fields.map(function (field) { return (React.createElement(Field, { key: field.column ? field.column : field.name, field: __assign(__assign({}, field), { value: values[field.column ? field.column : field.name] === 0 ? '0' : values[field.column ? field.column : field.name] || '' }), onChange: _this.handleChange })); }),
            taxValue && this.props.calculator &&
                React.createElement(Calculator, { taxValue: taxValue, styles: { width: '100%', } }),
            React.createElement(ButtonsBar, null,
                hasParent && (React.createElement(StyledButton, { onClick: this.handleCancel }, t('cancel'))),
                this.props.values && canBeDisabled ? (disabled ? (React.createElement(StyledButton, { isDisabled: true, onClick: this.handleDisable(false) }, t('enable'))) : (React.createElement(StyledButton, { onClick: this.handleDisable(true) }, t('disable')))) /*: canBeDeleted ? (
                  <StyledButton onClick={this.handleDelete}>
                    {t('delete')}
                  </StyledButton>
                )*/
                    : null,
                React.createElement(StyledButton, { onClick: this.handleReset }, t('reset')),
                React.createElement(StyledButton, { primary: true, loading: loading, onClick: this.handleSubmit }, t('save')))));
    };
    Form.prototype.parsedValues = function (props) {
        if (props === void 0) { props = this.props; }
        // console.log('props.values: ', props.values)
        var values = props.values || {};
        // console.log('values: ', values)
        // console.log('parsedValues - values', values)
        var result = this.fields.reduce(function (fields, field) {
            var _a;
            // console.log('field.column', field.column)
            var indice = field.column ? field.column : field.name;
            // console.log('indice', indice)
            // console.log('values[indice]', values[indice])
            return __assign(__assign({}, fields), (_a = {}, _a[indice] = values[indice]
                ||
                    (field.type === FieldType.Select
                        ? (field.placeholder
                            ? null
                            : field.options && field.options[0] && field.options[0].value)
                        : field.type === FieldType.Date ? values[indice] ? new Date(values[indice]) : null : values[indice]), _a));
        }, {});
        // console.log('parsedValues - result', result)
        return result;
    };
    return Form;
}(Component));
export default QueryParams(Form);
var Wrapper = cxs('div')((_a = {
        paddingBottom: Theme.size.bar
    },
    _a[mediaQueries.desktop] = {
        display: 'flex',
        flexWrap: 'wrap',
        // paddingBottom: 0
    },
    _a));
var StyledButton = cxs(Button)(function (_a) {
    var _b;
    var isDisabled = _a.isDisabled;
    return (_b = {
            color: isDisabled ? Theme.color.primary : 'inherit'
        },
        _b[mediaQueries.desktop] = {
            padding: Theme.size.space[2]
        },
        _b);
});
StyledButton.propTypes = {
    isDisabled: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Form.tsx
// module id = 1021
// module chunks = 0